import axios from "axios";
import ConstantList from "../../appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/region";

export const pagingRegions = (searchObject) => {
  var url = API_PATH + "/pagingRegions";
  return axios.post(url, searchObject);
};

export const getRegion = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createRegion = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editRegion = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteRegion = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const checkCode = (dto) => {
  var url = API_PATH + "/checkCode";
  return axios.post(url, {...dto});
};
